import React from "react";

export const BackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87742 8.36962L10.3123 2.27344L11.6878 3.72534L5.25291 9.82153C4.73119 10.3158 4.3393 10.6886 4.04606 10.9994H23V12.9994H4.04606C4.3393 13.3102 4.73119 13.683 5.2529 14.1772L11.6878 20.2734L10.3123 21.7253L3.82804 15.5824C3.15121 14.9412 2.57002 14.3907 2.16734 13.8888C1.73678 13.3521 1.40808 12.7496 1.40808 11.9994C1.40808 11.2492 1.73678 10.6467 2.16734 10.11C2.57002 9.60808 3.15121 9.05753 3.82805 8.41639C3.84445 8.40085 3.8609 8.38527 3.87742 8.36962Z"
      fill="#252525"
    />
  </svg>
);